//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//Unit Of Measure
export const GTE_UNIT_OF_MEASURE = "/unit_of_measure"


//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//file manager
export const GET_FOLDERS = "/file_manager/get_folders"
export const DELETE_FOLDER = "/file_manager/delete_folder"
export const RENAME_FOLDER = "/file_manager/rename_folder"
export const ADD_FOLDER = "/file_manager/add_folder_cms"

export const GET_FILES_BY_FOLDER = "/file_manager/get_files_by_folders"
export const DELETE_FILE = "/file_manager/delete_file"
export const ADD_FILE = "/file_manager/upload_file_to_folder"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"
export const ADD_NEW_INVOICE = "/add/invoice"
export const UPDATE_INVOICE = "/update/invoice"
export const DELETE_INVOICE = "/delete/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"
//ADMINS
export const GET_ADMINS = "/admins"
export const GET_ADMIN_PROFILE = "/user"
export const ADD_NEW_ADMIN = "/auth-admins/signup"
export const UPDATE_ADMIN = "/admins/put"
export const DELETE_ADMIN = "/admins/del"

//Settings
export const GET_SETTINGS = "/settings"
export const UPDATE_SETTING = "/settings/put"

//CEREMONIES
export const GET_CEREMONIES = "/ceremony_type"
export const ADD_NEW_CEREMONY = "/ceremony_type/add"
export const UPDATE_CEREMONY = "/ceremony_type/put"
export const DELETE_CEREMONY = "/ceremony_type/del"

export const GET_CEREMONIES_PACK = "/ceremony_pack"
export const ADD_NEW_CEREMONY_PACK = "/ceremony_pack/add"
export const UPDATE_CEREMONY_PACK = "/ceremony_pack/put"
export const DELETE_CEREMONY_PACK = "/ceremony_pack/del"

//vendor
export const GET_VENDOR_CATS = "/vendor_category"
export const ADD_NEW_VENDOR_CAT = "/vendor_category/add"
export const UPDATE_VENDOR_CAT = "/vendor_category/put"
export const DELETE_VENDOR_CAT = "/vendor_category/del"

export const GET_TYPE_SERVICES = "/vendor_type_services"
export const ADD_NEW_TYPE_SERVICE = "/vendor_type_services/add"
export const UPDATE_TYPE_SERVICE = "/vendor_type_services/put"
export const DELETE_TYPE_SERVICE = "/vendor_type_services/del"

export const GET_TYPE_SETTINGS = "/vendor_type_settings"
export const ADD_NEW_TYPE_SETTING = "/vendor_type_settings/add"
export const UPDATE_TYPE_SETTING = "/vendor_type_settings/put"
export const DELETE_TYPE_SETTING = "/vendor_type_settings/del"

export const GET_VENDORS = "/vendors"
export const ADD_NEW_VENDOR = "/vendors/add"
export const UPDATE_VENDOR = "/vendors/put"
export const DELETE_VENDOR = "/vendors/del"

export const GET_VENDOR_MEDIA = "/vendor_media"
export const ADD_NEW_VENDOR_MEDIA = "/vendor_media/add"
export const UPDATE_VENDOR_MEDIA = "/vendor_media/put"
export const DELETE_VENDOR_MEDIA = "/vendor_media/del"

export const GET_VENDOR_PRICING = "/vendor_pricing"
export const ADD_NEW_VENDOR_PRICING = "/vendor_pricing/add"
export const UPDATE_VENDOR_PRICING = "/vendor_pricing/put"
export const DELETE_VENDOR_PRICING = "/vendor_pricing/del"

export const GET_VENDOR_EVENT = "/vendor_events"
export const ADD_NEW_VENDOR_EVENT = "/vendor_events/add"
export const UPDATE_VENDOR_EVENT = "/vendor_events/put"
export const DELETE_VENDOR_EVENT = "/vendor_events/del"
//clients
export const GET_CLIENTS = "/clients"
export const ADD_NEW_CLIENT = "/clients/add"
export const ADD_NEW_PARTNER = "/clients/partner_register"
export const UPDATE_CLIENT = "/clients/put"
export const DELETE_CLIENT = "/clients/del"

//events
export const GET_EVENTS_1 = "/get_events"
export const ADD_NEW_EVENT_1 = "/get_events/add"
export const UPDATE_EVENT_1 = "/get_events/put"
export const DELETE_EVENT_1 = "/get_events/del"

//clients_purchase
export const GET_PURCHASES = "/clients_purchase/get_purchases"
export const ADD_NEW_PURCHASE = "/clients_purchase/add"
export const UPDATE_PURCHASE = "/clients_purchase/edit_unclock_purchase"
export const DELETE_PURCHASE = "/clients_purchase/del"

export const GET_REVIEWS = "/reviews/get_all"
export const ADD_NEW_REVIEW = "/reviews/add"
export const UPDATE_REVIEW = "/reviews/put"
export const DELETE_REVIEW = "/reviews/del"

//budget percentage
export const GET_BUDGETS_PERCENTAGE = "/budget_percentage"
export const ADD_NEW_BUDGET_PERCENTAGE = "/budget_percentage/add"
export const UPDATE_BUDGET_PERCENTAGE = "/budget_percentage/put"
export const DELETE_BUDGET_PERCENTAGE = "/budget_percentage/del"


//ADDRESS
export const GTE_COUNTRIES = "/address/countries"
export const GET_CITIES = "/address/cities"
export const GET_CITIES_BY_COUNTRY = "/address/cities/"
//ADDRESS
export const GET_HOWITWORK = "/how_it_works"
export const GET_HOWITWORKS = "/how_it_works"
export const ADD_NEW_HOWITWORKS = "/how_it_works/add"
export const UPDATE_HOWITWORKS = "/how_it_works/put"
export const DELETE_HOWITWORKS = "/how_it_works/del"

export const GET_FAQ = "/faq"
export const GET_FAQS = "/faq"
export const ADD_NEW_FAQS = "/faq/add"
export const UPDATE_FAQS = "/faq/put"
export const DELETE_FAQS = "/faq/del"
